import * as React from 'react'

export type WarningProps = React.SVGProps<SVGSVGElement>

export const Warning = (props: WarningProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 28 28"
    fill="#F00000"
    {...props}
  >
    <path
      d="M12.884 2.532c-.346-.654-1.422-.654-1.768 0l-9 17A.999.999 0 0 0 3 21h18a.998.998 0 0 0 .884-1.468l-9-17zM13 18h-2v-2h2v2zm0-4h-2v-4h2v4z"
      strokeLinejoin="round"
    />
  </svg>
)
